module.exports = __webpack_public_path__ + "img/Euro.908ec515.svg";